import PlainLeague from "../PlainLeague";
import React from "react";
import { League } from "../../models/League";
import withDefaultProps from 'functions/withDefaultProps';

const defaultProps = {
	restriction: {
		direction: 0,
	}
};
export default function RankedRestrictionTierDisplay(incomingProps) {
	const props = withDefaultProps(incomingProps, defaultProps);
	const { restriction, tier, ladder, showDivisionIfSelected, showIncludingUnrankedAlso } = props;
	const season = ladder.getActiveSeason();
	if(!season) {
		console.error('no active season for this ladder');
		return null;
	}
	if(!season.tiers) {
		console.error('Season has no tiers');
		return null;
	}
	const unrankedTier = season.getUnrankedTier();
	let division = null;
	if(showDivisionIfSelected && restriction.division) {
		division = League.divisionNumberToRomanNumeral(restriction.division);
	}

	return (
		<div className='ranked_restriction_details'>
			<PlainLeague
				league={tier}
				name={tier === unrankedTier ? ' ' : undefined}
				showDivision={!!division}
				divisionOverride={division}
			/>
			<div
				className='hint'>
				{restriction.direction === 0 && <span>No Restrictions</span>}
				{restriction.direction >= 1 && <span>And Above Only</span>}
				{restriction.direction <= -1 && <span>And Below Only</span>}
			</div>
			{showIncludingUnrankedAlso && restriction.direction === -2 &&
			<div>+ Unranked</div>
			}
		</div>
	);
}